import { position, PositionProps } from 'styled-system';
import styled from '../styled';
import StyledChildren from './StyledChildren';

export default styled(StyledChildren)<PositionProps>(position);
